import React, {useEffect, useRef, useState} from "react";
import { useLatest, useUpdateEffect } from "ahooks";
import HasPermission from "@/components/commons/HasPermission";
import { useGroupDeviceDispatch, useGroupDeviceState } from "../Provider";
import { useGlobalState,useGlobalDispatch } from "../../../GlobalProvider";
import CategoryTreeWrapper from "./CategoryTreeWrapper";
import ImportGroupDialog from "./Import/ImportDialog";
import localforage from "localforage";
import { useHistory, useLocation } from 'react-router-dom';

const Category = React.memo(() => {
  const tree = useRef(null);
  const [importDialogOpen, setImportDialogOpen] = useState(false);
  const [importGroupId, setImportGroupId] = useState("");
  const {
    setCurrentGroup,
    updateCurrentGroup,
    resetCurrentGroup,
    setShowDetail,
    reloadStoreList
  } = useGroupDeviceDispatch();

  const { currentTag, filterByMode, filterBy, reloadTreeFlag, currentGroup,currentCompanyId,showDetail } = useGroupDeviceState();

  const currentGroupRef = useLatest(currentGroup);
  const filterByModeRef = useLatest(filterByMode);
  const filterByRef = useLatest(filterBy);

  const [selectedKeys, setSelectedKeys] = useState(
    currentTag || filterByMode ? [] : undefined
  );
  const [checkedKeys, setCheckedKeys] = useState();

  const handleCheck = (checkedKeys, info) => {
    updateCurrentGroup({ id: checkedKeys, checkedGroups: info.checkedNodes });
  };


  const handleSwitch = on => {
    if (on) {
      updateCurrentGroup({ checkedGroups: [] });
    } else {
      resetCurrentGroup(false, state => {
        if (state.currentGroup) {
          setSelectedKeys([state.currentGroup.key]);
        }
      });
    }
  };

  const handleSetCurrentGroup = (keys, nodeInfo) => {
    setCurrentGroup(nodeInfo.node, true);
    if(nodeInfo.node.id === 'all') {
      // 刷新数据
      if(showDetail === false){
        reloadStoreList()
        return;
      }

      setShowDetail(false)
      return
    }
    // 弹出门店详情页面
    setShowDetail(true,nodeInfo.node.id,'show')

  };

  const handleLoaded = treeData => {
    setCurrentGroup(treeData[0], true);
  };

  const onNodeImport = nodeInfo => {
    setImportDialogOpen(true);
    if (nodeInfo.isRoot) {
      setImportGroupId("");
    } else {
      setImportGroupId(nodeInfo.key);
    }
  };

  const onImportGroupSuccess = () => {
    tree.current?.reload();
  };

  useUpdateEffect(() => {
    if (reloadTreeFlag) {
      tree.current?.reload(true);
    }
  }, [reloadTreeFlag]);

  useUpdateEffect(() => {
    if (currentTag || filterByMode) {
      setSelectedKeys([]);
      // setCurrentGroup(tree.current?.getTreeData()[0]);
    }
  }, [currentTag, filterByMode]);

  useEffect(()=>{
    if(!showDetail){
      tree.current?.reload();
    }
  },[showDetail])

  return (
    <>
      <HasPermission permission="merchant_maintain_group">
        {editable => (
          <HasPermission permission="merchant_move_group">
            {sortable => (
              <HasPermission permission="merchant_group_import">
                {importable => (
                  <CategoryTreeWrapper
                    showSwitch={false}
                    ref={tree}
                    editable={editable}
                    sortable={sortable}
                    checkable={checkedKeys}
                    disabledCheckAllNode
                    checkStrictly
                    selectable={!currentGroup || !currentGroup.checkedGroups}
                    selectedKeys={selectedKeys}
                    checkedKeys={checkedKeys}
                    importable={importable}
                    onSelect={handleSetCurrentGroup}
                    onCheck={handleCheck}
                    onSwitch={handleSwitch}
                    onLoaded={handleLoaded}
                    onNodeImport={onNodeImport}
                  />
                )}
              </HasPermission>
            )}
          </HasPermission>
        )}
      </HasPermission>
      <ImportGroupDialog
        open={importDialogOpen}
        groupId={importGroupId}
        onSuccess={onImportGroupSuccess}
        onClose={() => setImportDialogOpen(false)}
      />
    </>
  );
});

export default Category;
